import React, {useEffect, useLayoutEffect, useState} from "react";
import {Divider, Radio} from 'antd';
import * as utils from "../lib/Utils";
import Button from "antd/es/button";
import { useDerivedObject} from "../uiUtils/hooks";
import {capitalize, mapValues, pick} from 'lodash';
import {RollbackOutlined} from "@ant-design/icons";
import {DividerTitle, Label} from "../uiUtils/Helpers";
import {PrintOutput} from "./PrintOutput";
import {WebOutput} from "./WebOutput";


// todo find way to deal with ads missing dims
//  send setWidth calls into tails spin otherwise...
//  could get preview dimensions and match ratio to typical sizes
//const defaultSize = {width: sizes.PASS[1], height: 5};


export default function MediaSetter(
    {
        onOutputChange= ()=>{},
        onMediumChange= ()=>{},
        output,
        adInfo,
        keepAspectRatio, setKeepAspectRatio,
        template,
        maxDimensionChange = 25, //percent
        maxAreaChange = 34, //percent
        maxRatioChange = 40 //percent
    })
{
    // Note using derived object that maintains same object if the output is unchanged
    // using another state var caused unneeded and troublesome re-renders
    const pixelDimensions = useDerivedObject( output,
        output=> mapValues(
            pick(output,'width','height'),
            (v)=>utils.inchesToPixels(v)
        ),
        {width:0,height:0}
    );

    const [showSizeWarning, setShowSizeWarning] = useState(false);

    useLayoutEffect(()=>{
        if (template && output.width && keepAspectRatio) {
            const {width, height} = template;
            const newHeight = utils.round(output.width * height / width,3);
            if (output.height !== newHeight) {
                console.log('Setting height from width', output);
                updateOutput({height:newHeight});
            }
        }
    },[output.width, keepAspectRatio, template]);

    const tooMuch = (from, to, max) => Math.abs(from - to ) / from > max/100 ;
    const ratioChange = (from, to, max) => Math.abs(1 - to / from )> max/100 ;

    function updateOutput(newOutput={}){
        const {width, height} = newOutput; // these are also inches...

        if (template && width && height) {
            const {widthInches,  heightInches} = template;
            const widthIssue = tooMuch(widthInches, width, maxDimensionChange);
            const heightIssue = tooMuch(heightInches, height, maxDimensionChange);
            const areaIssue = tooMuch(widthInches * heightInches, width * height, maxAreaChange);
            const ratioIssue = ratioChange(widthInches / heightInches, width / height, maxRatioChange);
            setShowSizeWarning(widthIssue || heightIssue || areaIssue || ratioIssue);
            console.log({widthIssue, heightIssue, areaIssue, ratioIssue});
            console.log(newOutput, output);
        }
        onOutputChange(newOutput);
    }

    function setOutputFromPixels(pixelDims) {
        //console.log('setOutputFromPixels: ',pixelDims);
        updateOutput(mapValues(pixelDims,(v)=>utils.pixelsToInches(v)));
    }

    const resetSizeFromTemplate = template => {
        const {widthInches: width, heightInches: height} = template;
        updateOutput({width, height});
        // todo ?
        setMedium(capitalize(template.medium)); // MMC uses lowercase..
    };

    const setColor = color=>updateOutput({color});
    const setMedium = medium=>onMediumChange({medium});

    const setPrintInfo = printSizeInfo=> {
        onMediumChange({
            sizeName: printSizeInfo.name,
            ...pick(printSizeInfo, 'standard', 'columns')
        });
    }

    return (
        <>
            <DividerTitle>Media <Button size={'small'} icon={<RollbackOutlined />} type={'link'}
                                        onClick={()=>resetSizeFromTemplate(template)} >
                reset</Button></DividerTitle>
            <Label>Size for</Label>
            <Radio.Group onChange={e=>setMedium(e.target.value)} value={adInfo.medium}
                         buttonStyle="solid" size={'small'}>
                <Radio.Button value='Print'>Print</Radio.Button>
                <Radio.Button value='Web'>Web</Radio.Button>
            </Radio.Group>
            <p/>
            <Div visible={adInfo.medium==='Web'}>
                <WebOutput dimensions={pixelDimensions} onChange={setOutputFromPixels}
                           onNameChange={sizeName=>onMediumChange({sizeName})} template={template}
                           keepAspectRatio={keepAspectRatio} setKeepAspectRatio={setKeepAspectRatio}
                />
            </Div>
            <Div visible={adInfo.medium!=='Web'}>
                <PrintOutput dimensions={output} onChange={updateOutput}
                             onNameChange={setPrintInfo} template={template}
                             keepAspectRatio={keepAspectRatio} setKeepAspectRatio={setKeepAspectRatio}
                />
                <p/>
            </Div>
            {showSizeWarning && <div style={{color:'salmon', marginTop: 3}}>
                Warning: The dimensions of this ad have been significantly altered which may cause problems with the auto layout.
            </div> }

            <Divider/>
            <Label>Color</Label>
            <Radio.Group
                onChange={e=>setColor(e.target.value)} value={output.color}
                buttonStyle="solid" size={'small'}
            >
                <Radio.Button value='Color'>Color</Radio.Button>
                <Radio.Button value='Black & White'>Black & White</Radio.Button>
            </Radio.Group>
        </>
    );
}

function Div({visible, style, ...props}){
    return <div style={visible?style:{display:'none'}} {...props}/>
}

/*
{ adInfo.medium==='Web' ?
                <WebOutput dimensions={webOutput} onChange={setOutputFromPixels}
                    onNameChange={sizeName=>onMediumChange({sizeName})} template={template} />
            :
            <>
                <PrintOutput template={template} dimensions={output} onChange={updateOutput}
                             onNameChange={setPrintInfo}/>
                <p/>
            </>}
 */